// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-fwwgl-shwpgl-index-main_right_content-2k4Mn","table":"components-fwwgl-shwpgl-index-table-3x_V4"};


//////////////////
// WEBPACK FOOTER
// ./components/fwwgl/shwpgl/index.css
// module id = 2286
// module chunks = 0